import { useEffect } from 'react';
import { isSessionExpired, hasSession, logoutWithMessage } from './session';
import { useLocation, useNavigate } from 'react-router-dom';

export default function SessionGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const protectedAdminRoutes = ['/menu/admin'];
    const protectedStaffRoutes = ['/menu/faces'];

    // Don't check session on login route
    if (location.pathname === '/login') return;

    // Check protected routes
    if (!localStorage.getItem('facesToken')) navigate('/login');
    if (
      localStorage.getItem('facesStaff') !== 'true' &&
      protectedStaffRoutes.includes(location.pathname)
    )
      navigate('/menu');
    if (
      localStorage.getItem('facesAdmin') !== 'true' &&
      protectedAdminRoutes.includes(location.pathname)
    )
      navigate('/menu');

    const interval = setInterval(() => {
      if (hasSession() && isSessionExpired()) {
        logoutWithMessage('Your session expired. Please log in again.');
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [location.pathname, navigate]);
  return children;
}
